import { Dict } from "@/types/generalTypes";
import { SfWordCategory } from "@/types/spellingTypes";

export default (rawData: SfWordCategory[]) => {
  const parents: Dict<SfWordCategory> = {};
  for (const ca of rawData) {
    if (ca.word_count < 1) {
      parents[ca.id] = ca;
    }
  }
  const res: SfWordCategory[] = [];
  for (const ca of rawData) {
    if (ca.parent_category_id == null) {
      res.push(ca);
    } else {
      if (!parents[ca.parent_category_id].subCategories) {
        parents[ca.parent_category_id].subCategories = [];
      }
      parents[ca.parent_category_id].subCategories?.push(ca);
    }
  }
  return res;
};
